import { useContext } from "react";

import TableContext from "context/table/tableContext";
import { FILTER_NAMES } from "shared/types/enums";

import DeviceDetailTwoFilters from "./shared/DeviceDetailTwoFilters";
import {
    TASK_STATUS,
    TASK_TYPE
} from "./shared/DeviceDetailTwoFilters/constants";

export const DeviceDetailTaskFilters = () => {
    const { innerTableQueryParams } = useContext(TableContext);

    const additionalParams = `${[FILTER_NAMES.DeviceImei]}=${innerTableQueryParams[FILTER_NAMES.DeviceImei]}`;

    return (
        <DeviceDetailTwoFilters
            firstFilter={FILTER_NAMES.TaskStatus}
            secondFilter={FILTER_NAMES.Type}
            firstFilterPlaceholder={TASK_STATUS}
            secondFilterPlaceholder={TASK_TYPE}
            additionalParams={additionalParams}
        />
    );
};
